import NavBar from "../../component/NavBar/NavBar";
import LoginMain from "../../component/Member/components/LoginMain/LoginMain";

function Login() {
    return (
        <>
            <NavBar />
            <LoginMain />
        </>
    );
}

export default Login;